import { PageHero } from '../components/ui/PageHero';
import { FAQList } from '../components/ui/FAQList';
import { CTAButton } from '../components/ui/CTAButton';
import { FAQ_CATEGORIES } from '../constants/content';

export default function FAQPage() {
  return (
    <>
      <PageHero
        title="常见问题"
        subtitle="关于 Ameowzing APP 与周边产品的常见疑问，为您解答。"
        breadcrumb={[{ label: '首页', path: '/' }, { label: '常见问题' }]}
      />

      <section className="container mx-auto px-4 py-16">
        <div className="max-w-3xl mx-auto mb-16">
          <FAQList categorized categories={FAQ_CATEGORIES} />
        </div>

        <div className="max-w-2xl mx-auto bg-white/5 rounded-2xl p-8 border border-purple-500/20 text-center">
          <h3 className="text-xl font-semibold mb-4">没有找到答案？</h3>
          <p className="text-purple-200 text-sm mb-6">
            您可以查阅使用教程，或联系技术支持获取帮助。
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <CTAButton to="/guide" variant="secondary">
              使用教程
            </CTAButton>
            <CTAButton to="/inquiry" variant="secondary" icon="fa-shopping-cart">
              购买咨询
            </CTAButton>
            <CTAButton to="/support" variant="primary">
              技术支持
            </CTAButton>
          </div>
        </div>
      </section>
    </>
  );
}
